export default {
    product: {
        description: {
            more: "więcej"
        },
        added: "Dodano do koszyka"
    }
}